.controls {
  display: flex;
  justify-content: center;
  margin-left: 19px;
  margin-right: 19px;
  border: 1px solid var(--dialog-border);
}

.controls > div {
  padding: 5px;
}

.controls svg {
  width: 1rem;
  cursor: pointer;
}

.disabled svg {
  fill: var(--main-text-soft);
  cursor: default;
}

.nav-item {
  padding: 5px 20px;
  width: 230px;
  display: flex;
}

.menu-item:hover {
  background-color: var(--hover-light);
}

.nav-item-child {
  padding: 5px 20px;
}

.selected {
  background-color: var(--hover-light);
}

.deleted {
  text-decoration: line-through;
}
